<template>
    <Widget bodyClass="mt" class="mb-xlg" id="izin-tahun-chart" :title="
        `<div class='row'>
        <div class='col-sm-12 col-xs-12 text-center'>
            <h5>
            PENERBITAN IZIN (${getYear.yPast}-${getYear.yNow})
            </h5>
        </div>
        <div class='col-xs-12 col-sm-7'>
            <div class='chart-legend' />
        </div>
        </div>`" customHeader collapse close>
        <apexchart type="bar" height="350" :key="testKey" :options="chartOptions" :series="series"></apexchart>
    </Widget>
</template>
   
<script>
// import Widget from '@/components/Widget/Widget';
// import { Chart } from 'highcharts-vue';
import axios from 'axios';
import VueApexCharts from 'vue-apexcharts'
var colorPalette = ['#00D8B6', '#008FFB', '#FEB019', '#FF4560', '#775DD0']
export default {
    name: 'IzinYearChart',
    components: {
        apexchart: VueApexCharts,
    },

    data() {
        return {
            baseapi: localStorage.getItem("baseapi"),
            user: JSON.parse(localStorage.getItem('user')),
            testKey: 0,
            // series: [],
            series: [{
                name: "PKKPRL",
                data: [],
            },
            {
                name: "Izin Lokasi",
                data: [],
            },
            {
                name: "KKRL",
                data: [],
            },
            {
                name: "Penetapan Lokasi",
                data: []
            },
            ],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 380,
                    width: '100%',
                    stacked: true,
                },
                zoom: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        columnWidth: '80%',
                        horizontal: false,

                        dataLabels: {
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    },

                },
                colors: colorPalette,
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: []
                },
                yaxis: {
                    // min: 0,
                    // max: 120,
                    // tickAmount: 2,
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        style: {
                            colors: '#78909c'
                        },

                    }
                },
                // legend: {
                //     position: 'left',
                //     offsetY: 50
                // },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],

            },
        };
    },

    mounted() {
        this.loaddata()
    },
    methods: {
        loaddata() {
          axios.get(this.baseapi + 'api/dashboard/yearChart', {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          }).then(response => {
            let array = []
            let namaArray = []
            let data = response.data.data;
            for (let index = 0; index < data.length; index++) {
                this.chartOptions.xaxis.categories.push(data[index].name)
                array.push(data[index].value)
                // namaArray.push()
                // console.log(this.chartOptions.xaxis.categories)
                // for (let index2 = 0; index2 < data.value.length; index2++) {
                //     console.log(data.value[index2])
                    
                // }
                // console.log(data[index].value.name)
            }
            // console.log(data[index].value.name)
            let num = 0
            for (let index = 0; index < array.length; index++) {
                // console.log(array[index])

                for (let index2 = 0; index2 < array[index].length; index2++) {
                    // if (index === index2) {
                        // console.log()
                        // console.log(array[index][index2])
                        if (array[index][index2].name == 'PKKPRL') {
                            this.series[0].data.push(array[index][index2].value)
                            // console.log(this.series[0].data)
                        } else if(array[index][index2].name == 'Izin Lokasi') {
                            this.series[1].data.push(array[index][index2].value)
                        } else if(array[index][index2].name == 'KKRL') {
                            this.series[2].data.push(array[index][index2].value)
                        } else {
                            this.series[3].data.push(array[index][index2].value)
                        }
                        // if (index2 == 0) {
                        //     console.log(array[index][index2])

                        //     this.series.push({ name: array[0][0].name, data: array[index][index2].})
                        // } 
                    //     console.log(index)
                    // } else {
                    //     continue
                    // }
                    this.testKey ++
                }
                // console.log(num)
                num ++
                // console.log(num)
            }
          }).catch(error => {
            console.log(error)
            return error
          });
        },
    },
    computed: {
        getYear: function() {
            let yNow = new Date().getFullYear()
            let yPast = yNow-4
            return { yNow, yPast }
        }
    }

};
</script>
   